import { createContext, Dispatch, useContext } from "react";
import { Graph_QL, System } from "../../../Services";
import { EsfSectionsInfo, StationInfo } from "../../../Services/Agrisys_GqlDataCaller/WalkThroughDataCalls/getEsfStructureCall";
import { TerminalInfo } from "../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getTerminalsCall";
import { systemControleTypes } from "../../LocationFeeder/_LocationFeeder/lfPenContext";
import { Section } from "../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getLfStructureCall";
import { Station } from "../../../Services/Agrisys_GqlDataCaller/StationCalls/queryStations";
import { Location } from "../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getLfStructureCall"

/* eslint-disable */
export enum currentEsfViewTypes {
  basic = "basic",
  systemControle = "systemControle",
  attention = "attention",
  remainingToday = "remainingToday",
  remainingYesterday = "remainingYesterday"
}

export enum IEsfContextEnum {
  locations = "locations",
  currentStationViewType = "currentStationViewType",
  error = "error",
  clearError = "clearError",
  systemControlePen = "systemControlePen",
  penContent = "penContent",

  selectedStations = "selectedStations",
  selectedSection = "selectedSection",
  selectedLocation = "selectedLocation",
  selectedMotors = "selectedMotors",
  locationResults = "locationResults",

  tempTerminalsData = "tempTerminalsData"
}
/* eslint-enable */

export type IEsfContext = {
  farm: string;
  domain: string;
  connection: Graph_QL.Connection;
  system: System;

  locations?: Location[];
  currentStationViewType: currentEsfViewTypes;
  penContent?: number;
  error: { Elementid: number, errorText: string };

  selectedStations?: Station[];
  selectedSection?: Section;
  selectedLocation?: Location;
  selectedMotors?: number[];
  
  tempTerminalsData?: TerminalInfo[];
  locationResults?: { [key: number]: boolean };
  systemControlePen?: {
    systemControleType?: systemControleTypes;
  }
};

export type EsfDispatcherT = Deep_Partial<IEsfContext>;

type EsfContexter = {
  state: IEsfContext,
  dispatch: Dispatch<EsfDispatcherT>
}

export const EsfContext = createContext<EsfContexter | undefined>(undefined);

export function EsfReducer(state: IEsfContext, action: EsfDispatcherT) {
  let ResultState = { ...state };
  Object.entries(action).forEach(([type, payload], index) => {
    switch (type) {
      case IEsfContextEnum.selectedSection: {
        const selectedStations = payload as Station[] | undefined;
        
        ResultState = {
          ...ResultState,
          selectedStations: selectedStations,
        };
        break;
      }
      case IEsfContextEnum.selectedLocation: {
        ResultState = {
          ...ResultState,
          selectedLocation: payload as Location | undefined,
        };
        break;
      }
      case IEsfContextEnum.selectedStations: {
        ResultState = {
          ...ResultState,
          selectedStations: payload as Station[]
        };
        break;
      }
      case IEsfContextEnum.selectedMotors: {
        ResultState = {
          ...ResultState,
          selectedMotors: payload as number[]
        };
        break;
      }
      case IEsfContextEnum.locations: {
        ResultState = {
          ...ResultState,
          locations: payload as Location[]
        };
        break;
      }
      case IEsfContextEnum.penContent: {
        ResultState = {
          ...ResultState,
          penContent: payload as number
        };
        break;
      }
      case IEsfContextEnum.systemControlePen: {
        ResultState = {
          ...ResultState,
          systemControlePen: {
            ...(ResultState.systemControlePen ?? {}),
            systemControleType: (payload as {systemControleType: systemControleTypes}).systemControleType 
          }
        };
        break;
      }
      case IEsfContextEnum.locationResults:
        ResultState = {
          ...ResultState,
          locationResults: payload as { [key: number]: boolean }
        };
        break;
      case IEsfContextEnum.currentStationViewType:
        ResultState = {
          ...ResultState,
          currentStationViewType: payload as currentEsfViewTypes
        };
        break;
      
        case IEsfContextEnum.tempTerminalsData:
          ResultState = {
            ...ResultState,
            tempTerminalsData: payload as TerminalInfo[]
          };
          break;
      
      case IEsfContextEnum.error:
        ResultState = {
          ...ResultState,
          error: payload as IEsfContext["error"]
        };
        break;
        case IEsfContextEnum.clearError:
          ResultState = {
            ...ResultState,
            error: { Elementid: 0, errorText: "" }
          };
          break;

      default:
        console.error(`Unhandled action type: ${type}`);
        break;
    }
  });
  return ResultState;
}

export function dispatchErrorWithTimeout(dispatch: any, payload: IEsfContext["error"], timeout = 2000) {
  dispatch({ error: payload });

  setTimeout(() => {
    dispatch({
      clearError: true
    });
  }, timeout);
}

export const useEsfContext = () => {
  const context = useContext(EsfContext);
  if (!context) {
    throw new Error("usePenContext must be used within a ModalProvider");
  }
  return context;
};